<div [class.is-invalid]="showError">
  <ng-container #fieldComponent></ng-container>
</div>